module.exports = __webpack_public_path__ + "img/default.e10f160c.svg";